import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import logo from "../../assets/logo-main.webp";
import styles from "./index.module.css";
import { getLatestReleaseUrl } from "./getLatestReleaseUrl";

const NAV_LINKS = [
  { label: "PRODUCTS", href: "/#touch-pos" },
  { label: "INFO", href: "/#info" },
  { label: "FEATURES", href: "/#features" },
  { label: "HARDWARE", href: "/hardware" },
  // { label: "PRICING", href: "/#pricing" },
  { label: "CONTACT", href: "/contact" },
  { label: "FAQ", href: "/#faq" },
  { label: "DOWNLOAD", href: "#" },
];

const TopNavigation = () => {
  const [showMobNav, setShowMobNav] = useState(false);

  const handleDownload = async () => {
    try {
      const url = await getLatestReleaseUrl();
      const link = document.createElement("a");
      link.href = url;
      link.download = url.split("/").pop() || "Epinics-POS-Setup.exe";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch {
      alert("Failed to fetch the latest installer. Please try again later.");
    }
  };

  const handleNavClick = (link, e) => {
    if (link.label === "DOWNLOAD") {
      e?.preventDefault();
      handleDownload();
    } else if (link.href.startsWith("/#")) {
      e?.preventDefault();
      const hash = link.href.slice(1);
      if (window.location.pathname === "/") {
        window.location.hash = hash.slice(1);
      } else {
        window.location.href = link.href;
      }
    } else if (link.href.startsWith("/")) {
      e?.preventDefault();
      window.location.href = link.href;
    }
    setShowMobNav(false);
  };

  return (
    <>
      <div className={styles.topNavContainer}>
        <a href="/" className={styles.logoLink}>
          <img className={styles.logo} src={logo} alt="Epinics" loading="lazy" />
        </a>

        <div className={styles.burgerIconDiv}>
          <RxHamburgerMenu
            className={styles.burgerIcon}
            onClick={() => setShowMobNav(!showMobNav)}
          />
        </div>

        <div className={styles.navLinkContainer}>
          {NAV_LINKS.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className={styles.navLink}
              onClick={(e) => handleNavClick(link, e)}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div
          className={`${styles.mobNav} ${showMobNav ? styles.mobNavShow : ""}`}
        >
          <div className={styles.logoDiv}>
            <div className={styles.left}>
              <img className={styles.logo} src={logo} alt="Epinics" loading="lazy" />
              <div className={styles.name}>EPINICS</div>
            </div>
            <div className={styles.right}>
              <IoClose onClick={() => setShowMobNav(false)} />
            </div>
          </div>
          {NAV_LINKS.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleNavClick(link, e)}
            >
              <div className={styles.mobNavLink}>{link.label}</div>
            </a>
          ))}
        </div>
      </div>
      <div className={styles.topNavSpacer} />
    </>
  );
};

export default TopNavigation;
